import './fetchPolyfill'
import FormData from 'form-data'
import config from '../config'
import DigitalStoreError from '../error'

const parseResponseData = (responseType, response) => {
  let data = response

  if (responseType === 'text' && typeof response === 'string') {
    try {
      data = JSON.parse(response)
    } catch (e) {
      // Error is not important, if the response type is text
      // and payload is valid JSON it will be parsed else
      // response will be passed on as normal.
    }
  }

  return data
}

const handleSomeTypeOfResponse = someType => response => {
  const { status } = response
  return response
    [someType || 'json']()
    .catch(err => {
      console.error('Failed to parse API response', response)
      throw err
    })
    .then((processedResponse) => parseResponseData(someType, processedResponse))
    .then(processedResponse => {
      if (status >= 200 && status < 300) {

        if (processedResponse.api === 'RetailOS V2') {
          return processedResponse.result
        }

        return processedResponse
      } else {

        if (processedResponse.api === 'RetailOS V2') {
          throw new DigitalStoreError({
            code: processedResponse.error.code,
            statusCode: status,
            message: processedResponse.error.message
          })
        }

        throw new DigitalStoreError(processedResponse)
      }
    })
}

const handleTextResponse = handleSomeTypeOfResponse('text')
const handleJsonResponse = handleSomeTypeOfResponse('json')
const handleResponse = handleJsonResponse

/**
 * Fetch
 * Wrapped fetch which will reject on response errors
 * @param {String} endpoint
 * @param {Object} options
 * @returns
 */
const wrappedFetch = (endpoint, options = { method: 'GET' }) => {
  // Get base url
  const { baseUrl, authToken } = config.getConfig()

  // construct full url
  const url = endpoint.startsWith('/')
    ? baseUrl + endpoint
    : endpoint

  let { responseType, noContentType, ...optionsRest } = options

  // Stringify body if not a FormData instance
  const body = options && options.body && !(options.body instanceof FormData)
    ? JSON.stringify(options.body)
    : options.body

  const authorisationHeader = authToken ? { 'Authorization': `Bearer ${authToken}` } : {}

  const headers = { ...authorisationHeader }
  if (!noContentType) {
    headers.Accept = 'application/json'
    headers['Content-Type'] = 'application/json'
  }

  return fetch(url, {
    headers,
    ...optionsRest,
    body
  })
  .then(handleSomeTypeOfResponse(responseType))
  .catch(err => {
    if (err.message === 'unsupported BodyInit type') {
      window.alert('Failed to upload file(s). Please try restarting the app.')
    }
    throw err
  })
}

// can't put this in a service or controller because
// there would be a circular dependency
const getFreshToken = () => {
  const {
    refreshToken,
    userId,
    endpointUrls,
    onRefresh = () => {} 
  } = config.getConfig()
  return wrappedFetch(endpointUrls.token(), {
    method: 'POST',
    body: { refreshToken, userId }
  })
    .then(result => {
      const { id, token, refreshToken } = result
      config.setConfig({
        userId: id,
        authToken: token,
        refreshToken
      })
      onRefresh(null, result)
    })
    .catch(err => {
      onRefresh(err)
      throw err
    })
}

const wrappedFetchWithTokenRefresh = (endpoint, options) => {
  const {
    endpointUrls
  } = config.getConfig()

  return wrappedFetch(endpoint, options)
    .catch(err => {
      // if the request is unauthorized (normally because token has expired)
      // attempt to refresh token
      // and if successful, attempt the request again
      if (err.statusCode === 403 || err.statusCode === 401) {
        // Not for login:
        if (endpoint !== endpointUrls.login()) {
          return getFreshToken()
            .then(() => wrappedFetch(endpoint, options))
            .catch((err) => { throw err })
        }
      }
      throw err
    })
}

export {
  handleTextResponse,
  handleJsonResponse,
  handleResponse,
  getFreshToken
}

export default wrappedFetchWithTokenRefresh



// WEBPACK FOOTER //
// ../src/lib/wrappedFetch.js